// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MileageSaarathi_summary_icons__2WwQe {
    color: #83a4cf;
    cursor: pointer;
    font-Size: 14px;
    margin-Left: 5px;
}

.MileageSaarathi_page_number_icons_prev__yrGBB {

    border-Radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none !important;
    background-color: #83a4cf;
    color: #3b4553
}

.MileageSaarathi_page_number_icons_prev__yrGBB:hover {

    background-color: #83a4cf !important;
    border-color: #83a4cf;
    color: white;
}

.MileageSaarathi_page_number_icons_prev__yrGBB:focus {

    background-color: #83a4cf !important;
    border-color: #83a4cf;
    color: white;
}

.MileageSaarathi_page_number_icons_next__yyHV2 {
    border-Radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none !important;
    background-color: white;
    color: #3b4553
}

.MileageSaarathi_page_number_icons_next__yyHV2:hover {
    background-color: #83a4cf !important;
    color: white;
    border-color: #83a4cf !important;
}

.MileageSaarathi_page_number_icons_next__yyHV2:focus {
    background-color: #83a4cf !important;
    color: white;
    border-color: #83a4cf !important;
}


.MileageSaarathi_sections_outline__\\+AA\\+Z {
    background-Color: #f1f2fb;
}

.MileageSaarathi_date_range_selection__apDzt {
    color: #364e69;
    font-Weight: bold;
}

.MileageSaarathi_download_button__EOsqO {
    color: #1769b4;
    font-Weight: 200;
}

.MileageSaarathi_summary_vehicle_numbers__Q8QSn {
    color: #364e69;
    font-Weight: normal;
}

.MileageSaarathi_efficiency_paratext__0-Idl {
    color: black;
    font-Weight: normal;
}

.MileageSaarathi_efficiency_paranum__k--Qe {
    background-Color: #cddaea;
    font-Weight: Bold;
}

.MileageSaarathi_graph_circles_energy__PqLsz {
    height: 12px;
    width: 12px;
    background-Color: #83a4cf;
    border-radius: 50%;
    display: inline-block;
    margin-Right: 6px;
}

.MileageSaarathi_graph_circles_distance__HNmJq {
    height: 12px;
    width: 12px;
    background-Color: #cddaea;
    border-radius: 50%;
    display: inline-block;
    margin-Right: 6px;
}

.MileageSaarathi_all_vehicles_button__xs8hA {
    background-Color: #83a4cf;
    border-Color: #1467b3;
}

.MileageSaarathi_table_vehicles_container__wz1wE {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_table__DXlDW {
    border-Radius: 12px;
    overflow: hidden;
}

.MileageSaarathi_tableHeaderRow__cQjue {
    background-color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_tableHeaderRow__cQjue th {
    cursor: pointer;
}

.MileageSaarathi_tableHeaderCell__USrNU {
    width: 20%;
}

.MileageSaarathi_sortIcon__Xvx5v {
    color: #fff;
}

.MileageSaarathi_textEnd__fIK1E {
    text-align: end;
}

.MileageSaarathi_insights_table__dJPIy {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_insights_fixed_col__cBnn6 {
    float: left;
    width: 47%;
    overflow: hidden;
}

.MileageSaarathi_insights_fixed_col_table__Zjwtu {
    border-radius: 12px 0 0 12px;
}

.MileageSaarathi_insights_fixed_col_tableheader__Q4dGi {
    background-color: #83a4cf;
    color: #fff;
    height: 60px;
}

.MileageSaarathi_insights_scroll_sec__-2IVj {
    margin-left: 47%;
    position: relative;
    border-left: 1px solid #dee2e6;
}

.MileageSaarathi_insights_fixed_col_tabledata__dggAc {
    background-color: #fff;
}

/* Arrows Styling */
.MileageSaarathi_insights_scroll_arrow__wDFPo {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #dee2e6;
    border-radius: 50%;
    font-size: 16px;
    color: #555;
    padding: 5px 8px;
    outline: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MileageSaarathi_insights_scroll_arrow__wDFPo:hover {
    background: rgba(131, 164, 207, 0.2);
}

/* Left Arrow */
.MileageSaarathi_left__ZxrhG {
    left: 5px;
}

/* Right Arrow */
.MileageSaarathi_right__XUuFg {
    right: 5px;
}

.MileageSaarathi_insights_scroll__euawv {
    overflow-x: scroll;
    width: 100%;
    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.MileageSaarathi_insights_scroll__euawv::-webkit-scrollbar {
    display: none;
}

.MileageSaarathi_insights_scroll_table__Pw-JD {
    border-radius: 0 12px 12px 0;
    min-width: 1000px;
}

.MileageSaarathi_insights_scroll_tablerow__9eyl0 {
    height: 60px;
    /* same height for both header rows */
    vertical-align: middle;
    text-align: center;
    background-Color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_insights_scroll_tabledata__PKiSt {
    background-color: #fff;
}

.MileageSaarathi_best_vehicle__nzrLf {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_best_vehicle_table__tAxrU {
    border-Radius: 12px;
    /* overflow: hidden; */
    border: 1px solid #dee2e6;
}

.MileageSaarathi_best_vehicle_table__tAxrU {
    border-Radius: 12px;
}

.MileageSaarathi_best_vehicle_tablerow__SO8jt {
    background-Color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_best_vehicle_tablerowstyle__G89yR {
    background-Color: #fff;
}

.MileageSaarathi_vehicle_analysis__oRHDs {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_vehicle_analysis_table__0C0gk {
    border-Radius: 12px;
}

.MileageSaarathi_vehicle_analysis_tablerow__H3yyf {
    background-Color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_vehicle_icon__ofiLe {
    width: 24px;
    height: 24px;
    background-Color: #83a4cf;
}

.MileageSaarathi_incidents_tab__ZejHs {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_incidents_tab_tablerow__1CDqu {
    background-Color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_incidents_tab_tablerowstyle__2BRz2 {
    background-Color: #fff;
}

.MileageSaarathi_incidents_tab_details__mrgaA {
    cursor: pointer;
    padding: 2px 6px;
    margin-Bottom: 4px;
    border: 1px solid #83a4cf;
    border-Radius: 4px;
    color: #83a4cf;
    font-Size: 12px;
    display: inline-block;
    background-Color: #fff;
    transition: background-color 0.2s ease;
}

.MileageSaarathi_incidents_tab_location__5jfpt {
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    padding: 2px 6px;
    border: 1px solid #83a4cf;
    border-Radius: 4px;
    color: #83a4cf;
    font-Size: 12px;
    display: inline-block;
    background-Color: #fff;
}

.MileageSaarathi_driver_behaviour__oVCDW {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;

}

.MileageSaarathi_driver_behaviour_tablerow__uuGB2 {
    background-Color: #83a4cf;
    color: #fff;
}

.MileageSaarathi_driver_behaviour_tablerowstyle__QPEKA {
    background-Color: #fff;
}

.MileageSaarathi_driver_behaviour_details__Goday {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-Color: rgba(0, 0, 0, 0.5);
    backdrop-Filter: blur(4px);
    z-Index: 9999;
    display: flex;
    justify-Content: center;
    align-Items: center;
    transition: all 0.3s ease;
}

.MileageSaarathi_service_summary__-4PFF {
    border-Radius: 12px;
    overflow: hidden;
}

.MileageSaarathi_service_summary_tablerow__9DfKi {
    background-Color: #83a4cf;
    color: #fff;
    position: sticky;
    top: 0;
}

.MileageSaarathi_service_summary_tablerowstyle__ytcJz {
    background-Color: #fff;
}

.MileageSaarathi_service_summary_vehicle_icon__QaA4U {
    width: 28px;
    height: 28px;
    background-Color: #83a4cf;
    font-Size: 14px;
}

.MileageSaarathi_filter_dropdown__hiqyg {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;
    cursor: pointer;

}

.MileageSaarathi_toggle_button__aLrAr {
    background-color: #ccc;
    cursor: pointer;

}

.MileageSaarathi_toggle_button__aLrAr:checked {
    background-color: #83a4cf !important;
}


.MileageSaarathi_toggle_button__aLrAr:focus {
    outline: none;
    box-shadow: none;
    background-image: none;
}

.MileageSaarathi_ms_button__3HNb\\+ {
    background-color: transparent;
    /* default */
    color: #4b88de;
    border: none;
    font-size: 13px;
    transition: background-color 0.3s ease;
    text-decoration: underline;
}

/* On hover */
.MileageSaarathi_ms_button__3HNb\\+:hover {
    background-color: #83a4cf !important;
    border-radius: 5px;
    color: white;
}

/* On focus */
.MileageSaarathi_ms_button__3HNb\\+:focus {
    background-color: transparent;
    outline: none;
}

.MileageSaarathi_service_modal_icon__0BgsF {
    color: #83a4cf !important;
    background-color: #e0ebf9 !important;
}

.MileageSaarathi_analysis_header__DQW5k {
    color: #364e69;
    font-Weight: bold;
    font-size: 20px;
}

.MileageSaarathi_selected_header__L9Af\\+ {
    color: #364e69;
    font-Weight: bold;
    font-size: 15px;
}

.MileageSaarathi_custom-close-btn__yf1c\\+ {
    color: #6c757d;
    background-color: transparent;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
}

.MileageSaarathi_custom-close-btn__yf1c\\+:hover,
.MileageSaarathi_custom-close-btn__yf1c\\+:focus,
.MileageSaarathi_custom-close-btn__yf1c\\+:active {
    color: #6c757d;
    background-color: transparent !important;
    /* this kills any Bootstrap override */
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MileageSarathiTab_bus/MileageSaarathi.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;AACpC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,eAAe;AACf;IACI,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;;AAEnB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;;AAEA,aAAa;AACb;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,wCAAwC;IACxC,sCAAsC;IACtC,gBAAgB;AACpB","sourcesContent":[".summary_icons {\n    color: #83a4cf;\n    cursor: pointer;\n    font-Size: 14px;\n    margin-Left: 5px;\n}\n\n.page_number_icons_prev {\n\n    border-Radius: 50%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border: none !important;\n    background-color: #83a4cf;\n    color: #3b4553\n}\n\n.page_number_icons_prev:hover {\n\n    background-color: #83a4cf !important;\n    border-color: #83a4cf;\n    color: white;\n}\n\n.page_number_icons_prev:focus {\n\n    background-color: #83a4cf !important;\n    border-color: #83a4cf;\n    color: white;\n}\n\n.page_number_icons_next {\n    border-Radius: 50%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border: none !important;\n    background-color: white;\n    color: #3b4553\n}\n\n.page_number_icons_next:hover {\n    background-color: #83a4cf !important;\n    color: white;\n    border-color: #83a4cf !important;\n}\n\n.page_number_icons_next:focus {\n    background-color: #83a4cf !important;\n    color: white;\n    border-color: #83a4cf !important;\n}\n\n\n.sections_outline {\n    background-Color: #f1f2fb;\n}\n\n.date_range_selection {\n    color: #364e69;\n    font-Weight: bold;\n}\n\n.download_button {\n    color: #1769b4;\n    font-Weight: 200;\n}\n\n.summary_vehicle_numbers {\n    color: #364e69;\n    font-Weight: normal;\n}\n\n.efficiency_paratext {\n    color: black;\n    font-Weight: normal;\n}\n\n.efficiency_paranum {\n    background-Color: #cddaea;\n    font-Weight: Bold;\n}\n\n.graph_circles_energy {\n    height: 12px;\n    width: 12px;\n    background-Color: #83a4cf;\n    border-radius: 50%;\n    display: inline-block;\n    margin-Right: 6px;\n}\n\n.graph_circles_distance {\n    height: 12px;\n    width: 12px;\n    background-Color: #cddaea;\n    border-radius: 50%;\n    display: inline-block;\n    margin-Right: 6px;\n}\n\n.all_vehicles_button {\n    background-Color: #83a4cf;\n    border-Color: #1467b3;\n}\n\n.table_vehicles_container {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.table {\n    border-Radius: 12px;\n    overflow: hidden;\n}\n\n.tableHeaderRow {\n    background-color: #83a4cf;\n    color: #fff;\n}\n\n.tableHeaderRow th {\n    cursor: pointer;\n}\n\n.tableHeaderCell {\n    width: 20%;\n}\n\n.sortIcon {\n    color: #fff;\n}\n\n.textEnd {\n    text-align: end;\n}\n\n.insights_table {\n    position: relative;\n    overflow: hidden;\n    border-radius: 12px;\n    border: 1px solid #dee2e6;\n}\n\n.insights_fixed_col {\n    float: left;\n    width: 47%;\n    overflow: hidden;\n}\n\n.insights_fixed_col_table {\n    border-radius: 12px 0 0 12px;\n}\n\n.insights_fixed_col_tableheader {\n    background-color: #83a4cf;\n    color: #fff;\n    height: 60px;\n}\n\n.insights_scroll_sec {\n    margin-left: 47%;\n    position: relative;\n    border-left: 1px solid #dee2e6;\n}\n\n.insights_fixed_col_tabledata {\n    background-color: #fff;\n}\n\n/* Arrows Styling */\n.insights_scroll_arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    background: rgba(255, 255, 255, 0.8);\n    border: 1px solid #dee2e6;\n    border-radius: 50%;\n    font-size: 16px;\n    color: #555;\n    padding: 5px 8px;\n    outline: none;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.insights_scroll_arrow:hover {\n    background: rgba(131, 164, 207, 0.2);\n}\n\n/* Left Arrow */\n.left {\n    left: 5px;\n}\n\n/* Right Arrow */\n.right {\n    right: 5px;\n}\n\n.insights_scroll {\n    overflow-x: scroll;\n    width: 100%;\n    scrollbar-width: none;\n    /* For Firefox */\n    -ms-overflow-style: none;\n    /* For IE and Edge */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.insights_scroll::-webkit-scrollbar {\n    display: none;\n}\n\n.insights_scroll_table {\n    border-radius: 0 12px 12px 0;\n    min-width: 1000px;\n}\n\n.insights_scroll_tablerow {\n    height: 60px;\n    /* same height for both header rows */\n    vertical-align: middle;\n    text-align: center;\n    background-Color: #83a4cf;\n    color: #fff;\n}\n\n.insights_scroll_tabledata {\n    background-color: #fff;\n}\n\n.best_vehicle {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.best_vehicle_table {\n    border-Radius: 12px;\n    /* overflow: hidden; */\n    border: 1px solid #dee2e6;\n}\n\n.best_vehicle_table {\n    border-Radius: 12px;\n}\n\n.best_vehicle_tablerow {\n    background-Color: #83a4cf;\n    color: #fff;\n}\n\n.best_vehicle_tablerowstyle {\n    background-Color: #fff;\n}\n\n.vehicle_analysis {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.vehicle_analysis_table {\n    border-Radius: 12px;\n}\n\n.vehicle_analysis_tablerow {\n    background-Color: #83a4cf;\n    color: #fff;\n}\n\n.vehicle_icon {\n    width: 24px;\n    height: 24px;\n    background-Color: #83a4cf;\n}\n\n.incidents_tab {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.incidents_tab_tablerow {\n    background-Color: #83a4cf;\n    color: #fff;\n}\n\n.incidents_tab_tablerowstyle {\n    background-Color: #fff;\n}\n\n.incidents_tab_details {\n    cursor: pointer;\n    padding: 2px 6px;\n    margin-Bottom: 4px;\n    border: 1px solid #83a4cf;\n    border-Radius: 4px;\n    color: #83a4cf;\n    font-Size: 12px;\n    display: inline-block;\n    background-Color: #fff;\n    transition: background-color 0.2s ease;\n}\n\n.incidents_tab_location {\n    display: none;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    padding: 2px 6px;\n    border: 1px solid #83a4cf;\n    border-Radius: 4px;\n    color: #83a4cf;\n    font-Size: 12px;\n    display: inline-block;\n    background-Color: #fff;\n}\n\n.driver_behaviour {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n\n}\n\n.driver_behaviour_tablerow {\n    background-Color: #83a4cf;\n    color: #fff;\n}\n\n.driver_behaviour_tablerowstyle {\n    background-Color: #fff;\n}\n\n.driver_behaviour_details {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-Color: rgba(0, 0, 0, 0.5);\n    backdrop-Filter: blur(4px);\n    z-Index: 9999;\n    display: flex;\n    justify-Content: center;\n    align-Items: center;\n    transition: all 0.3s ease;\n}\n\n.service_summary {\n    border-Radius: 12px;\n    overflow: hidden;\n}\n\n.service_summary_tablerow {\n    background-Color: #83a4cf;\n    color: #fff;\n    position: sticky;\n    top: 0;\n}\n\n.service_summary_tablerowstyle {\n    background-Color: #fff;\n}\n\n.service_summary_vehicle_icon {\n    width: 28px;\n    height: 28px;\n    background-Color: #83a4cf;\n    font-Size: 14px;\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    cursor: pointer;\n\n}\n\n.toggle_button {\n    background-color: #ccc;\n    cursor: pointer;\n\n}\n\n.toggle_button:checked {\n    background-color: #83a4cf !important;\n}\n\n\n.toggle_button:focus {\n    outline: none;\n    box-shadow: none;\n    background-image: none;\n}\n\n.ms_button {\n    background-color: transparent;\n    /* default */\n    color: #4b88de;\n    border: none;\n    font-size: 13px;\n    transition: background-color 0.3s ease;\n    text-decoration: underline;\n}\n\n/* On hover */\n.ms_button:hover {\n    background-color: #83a4cf !important;\n    border-radius: 5px;\n    color: white;\n}\n\n/* On focus */\n.ms_button:focus {\n    background-color: transparent;\n    outline: none;\n}\n\n.service_modal_icon {\n    color: #83a4cf !important;\n    background-color: #e0ebf9 !important;\n}\n\n.analysis_header {\n    color: #364e69;\n    font-Weight: bold;\n    font-size: 20px;\n}\n\n.selected_header {\n    color: #364e69;\n    font-Weight: bold;\n    font-size: 15px;\n}\n\n.custom-close-btn {\n    color: #6c757d;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    outline: none;\n    cursor: pointer;\n}\n\n.custom-close-btn:hover,\n.custom-close-btn:focus,\n.custom-close-btn:active {\n    color: #6c757d;\n    background-color: transparent !important;\n    /* this kills any Bootstrap override */\n    box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary_icons": `MileageSaarathi_summary_icons__2WwQe`,
	"page_number_icons_prev": `MileageSaarathi_page_number_icons_prev__yrGBB`,
	"page_number_icons_next": `MileageSaarathi_page_number_icons_next__yyHV2`,
	"sections_outline": `MileageSaarathi_sections_outline__+AA+Z`,
	"date_range_selection": `MileageSaarathi_date_range_selection__apDzt`,
	"download_button": `MileageSaarathi_download_button__EOsqO`,
	"summary_vehicle_numbers": `MileageSaarathi_summary_vehicle_numbers__Q8QSn`,
	"efficiency_paratext": `MileageSaarathi_efficiency_paratext__0-Idl`,
	"efficiency_paranum": `MileageSaarathi_efficiency_paranum__k--Qe`,
	"graph_circles_energy": `MileageSaarathi_graph_circles_energy__PqLsz`,
	"graph_circles_distance": `MileageSaarathi_graph_circles_distance__HNmJq`,
	"all_vehicles_button": `MileageSaarathi_all_vehicles_button__xs8hA`,
	"table_vehicles_container": `MileageSaarathi_table_vehicles_container__wz1wE`,
	"table": `MileageSaarathi_table__DXlDW`,
	"tableHeaderRow": `MileageSaarathi_tableHeaderRow__cQjue`,
	"tableHeaderCell": `MileageSaarathi_tableHeaderCell__USrNU`,
	"sortIcon": `MileageSaarathi_sortIcon__Xvx5v`,
	"textEnd": `MileageSaarathi_textEnd__fIK1E`,
	"insights_table": `MileageSaarathi_insights_table__dJPIy`,
	"insights_fixed_col": `MileageSaarathi_insights_fixed_col__cBnn6`,
	"insights_fixed_col_table": `MileageSaarathi_insights_fixed_col_table__Zjwtu`,
	"insights_fixed_col_tableheader": `MileageSaarathi_insights_fixed_col_tableheader__Q4dGi`,
	"insights_scroll_sec": `MileageSaarathi_insights_scroll_sec__-2IVj`,
	"insights_fixed_col_tabledata": `MileageSaarathi_insights_fixed_col_tabledata__dggAc`,
	"insights_scroll_arrow": `MileageSaarathi_insights_scroll_arrow__wDFPo`,
	"left": `MileageSaarathi_left__ZxrhG`,
	"right": `MileageSaarathi_right__XUuFg`,
	"insights_scroll": `MileageSaarathi_insights_scroll__euawv`,
	"insights_scroll_table": `MileageSaarathi_insights_scroll_table__Pw-JD`,
	"insights_scroll_tablerow": `MileageSaarathi_insights_scroll_tablerow__9eyl0`,
	"insights_scroll_tabledata": `MileageSaarathi_insights_scroll_tabledata__PKiSt`,
	"best_vehicle": `MileageSaarathi_best_vehicle__nzrLf`,
	"best_vehicle_table": `MileageSaarathi_best_vehicle_table__tAxrU`,
	"best_vehicle_tablerow": `MileageSaarathi_best_vehicle_tablerow__SO8jt`,
	"best_vehicle_tablerowstyle": `MileageSaarathi_best_vehicle_tablerowstyle__G89yR`,
	"vehicle_analysis": `MileageSaarathi_vehicle_analysis__oRHDs`,
	"vehicle_analysis_table": `MileageSaarathi_vehicle_analysis_table__0C0gk`,
	"vehicle_analysis_tablerow": `MileageSaarathi_vehicle_analysis_tablerow__H3yyf`,
	"vehicle_icon": `MileageSaarathi_vehicle_icon__ofiLe`,
	"incidents_tab": `MileageSaarathi_incidents_tab__ZejHs`,
	"incidents_tab_tablerow": `MileageSaarathi_incidents_tab_tablerow__1CDqu`,
	"incidents_tab_tablerowstyle": `MileageSaarathi_incidents_tab_tablerowstyle__2BRz2`,
	"incidents_tab_details": `MileageSaarathi_incidents_tab_details__mrgaA`,
	"incidents_tab_location": `MileageSaarathi_incidents_tab_location__5jfpt`,
	"driver_behaviour": `MileageSaarathi_driver_behaviour__oVCDW`,
	"driver_behaviour_tablerow": `MileageSaarathi_driver_behaviour_tablerow__uuGB2`,
	"driver_behaviour_tablerowstyle": `MileageSaarathi_driver_behaviour_tablerowstyle__QPEKA`,
	"driver_behaviour_details": `MileageSaarathi_driver_behaviour_details__Goday`,
	"service_summary": `MileageSaarathi_service_summary__-4PFF`,
	"service_summary_tablerow": `MileageSaarathi_service_summary_tablerow__9DfKi`,
	"service_summary_tablerowstyle": `MileageSaarathi_service_summary_tablerowstyle__ytcJz`,
	"service_summary_vehicle_icon": `MileageSaarathi_service_summary_vehicle_icon__QaA4U`,
	"filter_dropdown": `MileageSaarathi_filter_dropdown__hiqyg`,
	"toggle_button": `MileageSaarathi_toggle_button__aLrAr`,
	"ms_button": `MileageSaarathi_ms_button__3HNb+`,
	"service_modal_icon": `MileageSaarathi_service_modal_icon__0BgsF`,
	"analysis_header": `MileageSaarathi_analysis_header__DQW5k`,
	"selected_header": `MileageSaarathi_selected_header__L9Af+`,
	"custom-close-btn": `MileageSaarathi_custom-close-btn__yf1c+`
};
export default ___CSS_LOADER_EXPORT___;
